module.exports = "/_next/static/images/icon-top-arrow-544d56e1.png";